import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { DYNAMIC_ERROR_STATE_MATCHER } from '../../services/dynamic-control-error-state-matcher';

@Component({
  selector: 'lib-text-area-control',
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    MatHint,
    CommonModule,
  ],
  templateUrl: './text-area-control.component.html',
  styleUrl: './text-area-control.component.scss',
})
export class TextAreaComponent {
  @Input() control: any;
  @Input() resizeDisabled: boolean;

  inputControl: FormControl;
  errorStateMatcher = DYNAMIC_ERROR_STATE_MATCHER;
  label: string;
  maxLength: number;
  isReadonly: boolean;

  private _subscriptions: Subscription[] = [];

  constructor() {}

  ngOnInit() {
    this.inputControl = this.control.formControls[0].formControl;
    this.label = this.control.label;
    this.maxLength = this.control.customOptions?.maxLength;
    this.isReadonly = this.control.isReadonly;
  }

  ngOnDestroy() {
    this._subscriptions.forEach((i) => i.unsubscribe());
  }
}
